
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60911_8056)"}},[_c('path',{attrs:{"d":"M12 14L22.392-1H1.608L12 14z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.25 21.75h7.5M11.6 14l2.4-4h-4l2.4-4m-5.022 9.656A7.488 7.488 0 014.5 9.792c-.022-4.065 3.255-7.448 7.32-7.542a7.5 7.5 0 014.812 13.397 2.28 2.28 0 00-.882 1.79V18a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v-.563a2.26 2.26 0 00-.872-1.78z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60911_8056"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    